import type StudyParticipantModel from '../../../models/StudyParticipantModel';
import { requestAndParse, requestSuccessful } from '../request';

const getStudyParticipants = async (studyId?: number) => {
    const route = 'admin/get-study-participants';
    const payload = { studyId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const participants = (response.body?.participants ??
        []) as StudyParticipantModel[];

    return { success, participants };
};

export default getStudyParticipants;
